import { Button as WSRButton, ButtonProps as WSRButtonProps } from '@wix/design-system'
import React, { FC, memo, MouseEventHandler } from 'react'

import { ContentWithLoading } from './ContentWithLoading'

type ButtonProps = WSRButtonProps & {
  label: string
  onClick: MouseEventHandler<HTMLElement>
  isLoading?: boolean
}

const noop = () => {}

export const Button: FC<ButtonProps> = memo(({ label, isLoading, size, onClick, skin, ...props }) => (
  <WSRButton {...props} onClick={isLoading ? noop : onClick} size={size ?? 'large'} skin={skin ?? 'dark'}>
    <ContentWithLoading isLoading={isLoading}>{label}</ContentWithLoading>
  </WSRButton>
))
